import React from 'react'

import Box from 'components_new/atoms/Box'
import Skeleton from 'components_new/atoms/Skeleton'

const Loading = () => {
  return (
    <Box sx={{ mb: 3 }}>
      <Skeleton variant="rounded" height={48} width={'50%'} />
    </Box>
  )
}

Loading.displayName = 'Loading'

export default Loading
